import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";

import { FeedbackModal } from "./feedback-modal";

type SupportContextValue = {
  isFeedbackOpen: boolean;
  openFeedback: () => void;
  closeFeedback: () => void;
};

const SupportContext = createContext<SupportContextValue | null>(null);

export function SupportProvider({ children }: { children: ReactNode }) {
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);

  const openFeedback = useCallback(() => setIsFeedbackOpen(true), []);
  const closeFeedback = useCallback(() => setIsFeedbackOpen(false), []);

  const value = useMemo(
    () => ({ isFeedbackOpen, openFeedback, closeFeedback }),
    [isFeedbackOpen, openFeedback, closeFeedback],
  );

  return (
    <SupportContext.Provider value={value}>
      {children}
      <FeedbackModal open={isFeedbackOpen} onClose={closeFeedback} />
    </SupportContext.Provider>
  );
}

export function useSupport(): SupportContextValue {
  const ctx = useContext(SupportContext);
  if (!ctx) {
    throw new Error("useSupport must be used inside a SupportProvider");
  }
  return ctx;
}
